export default __webpack_public_path__ + "static/media/ODToroClosed.32cf0612.jpg";